export default function canManageMarketingCampaigns(state) {
    return Boolean(state?.config?.flagsmith?.spamchimp);
}
